import * as Services from "../services/Services"
import * as Url from "../services/Url"


export const getAllRoute = async() => {
  let token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_ROUTES, token)
  return res;
};

export const getAllRoutebyContractor = async(tenant_id) => {
  let token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_ROUTES_BY_CONTRACTOR+tenant_id, token)
  return res;
};

export const getRouteDetails = async(id) => {
  let token = localStorage.getItem("token");
  let res = await Services.GET(`${Url.GET_ROUTE_DETAILS}/${id}`, token)
  return res;
};

export const addRoute = async(payload) => {
  let token = localStorage.getItem("token");
  let res = await Services.POST(Url.ADD_ROUTE, payload, token)
  return res;
};
export const updateRoute = async(id, payload) => {
  let token = localStorage.getItem("token");
  let res = await Services.PUT(`${Url.UPDATE_ROUTE}/${id}`, payload, token)
  return res;
};
export const deleteRouteByID = async(id) => {
  let token = localStorage.getItem("token");
  let res = await Services.DELETE(`${Url.DELETE_ROUTE}/${id}`, {}, token)
  return res;
};

export const getAllParcelAddressbyRoute = async(route_id, isDuplicate) => {
  let token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_PARCEL_BY_ROUTES+route_id+'&isDuplicate='+isDuplicate, token)
  return res;
};

export const uploadFile = async(formData) => {
  let token = localStorage.getItem("token");
  let res = await Services.UPLOAD(Url.UPLOAD_PARCEL_ADDRESS, formData, token)
  return res;
}

export const deleteAddressByID = async(id) => {
  let token = localStorage.getItem("token");
  let res = await Services.DELETE(`${Url.DELETE_ADDRESS}/${id}`, {}, token)
  return res;
};

export const uploadBulk = async(payload) => {
  let token = localStorage.getItem("token");
  let res = await Services.POST(Url.UPLOAD_BULK, payload, token)
  return res;
};

export const addParcelAddress = async(payload) => {
  let token = localStorage.getItem("token");
  let res = await Services.POST(Url.ADD_PARCEL_ADDRESS, payload, token)
  return res;
};

export const deleteParcelAddressByID = async(id) => {
  let token = localStorage.getItem("token");
  let res = await Services.DELETE(`${Url.DELETE_PARCEL_ADDRESS}/${id}`, {}, token)
  return res;
};

export const deleteAllParcelAddress = async(payload) => {
  let token = localStorage.getItem("token");
  let res = await Services.POST(Url.DELETE_ALL_PARCEL_ADDRESS, payload, token)
  return res;
};

export const getAllParcelAddressbyEmployee = async(employee_id) => {
  let token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_ALL_PARCEL_ADDRESS+employee_id, token)
  return res;
};
